<template>
    <div v-if="error.message" class="error">
      <v-alert prominent type="error" color="red lighten-2">
        <v-row align="center">
          <v-col class="grow white--text">
            {{ error.message }}
          </v-col>
          <v-col class="shrink">
            <v-btn
              v-show="error.allowRefresh"
              color="error"
              class="white--text"
              small
              outlined
              @mousedown="reloadApp()"
            >
              {{refreshButtonText}}
            </v-btn>
          </v-col>
          <v-col class="shrink">
            <button
              v-show="error.allowClose"
              type="button"
              class="close"
              aria-label="Close"
              @mousedown="closeError()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </v-col>
        </v-row>
      </v-alert>
    </div>
  </template>
  
  <script>

  export default {
    props: {
      error: {},
      refreshButtonText: {
        type: String,
        default: "Refresh",
      },
    },
    data() {
      return {
        errorMessage: "",
        allowClose: true,
        allowRefresh: true,
      };
    },
    methods: {
      reloadApp() {
        this.$emit("refresh");
      },
      closeError() {
        this.$emit("close");
      },
    },
    computed: {},
  };
  </script>
  
  <style scoped>
  .error {
    max-height: 25px !important;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  @media screen and (max-width: 700px) {
    .error p, div, span, label {
      font-size: 14px !important;
    }
    
    .error .v-alert__icon.v-icon {
      font-size: 24px !important;
    }

    .error .v-alert__icon.v-icon{
      height: 30px !important;
      width: 30px !important;
    }

    .error .v-btn{
      height: 40px !important;
    }
  }
  
  .v-btn {
    border-color: white !important;
  }
  
  .white--text /deep/ span {
    color: white !important;
  }
  
  .close {
    color: white !important;
    font-size: 32px !important;
  }
  </style>
  